import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import {
  StyledArrow,
  StyledButtonContainer,
  StyledButtonDownload,
  StyledButtonText,
  StyledLabel,
  StyledText,
  StyledWebcast,
  StyledWebcastContainer,
  StyleIconDownload,
  StyleIconMore,
} from './ButtonDownload.styled'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import { downloadDocument } from '../../utils/MenuButtonFunctions'
import { downloadDocumentEvent } from '../../utils/gtmEvents'
import LayoutContext from '../../contexts/LayoutContext'
import CheckPosition from '../../utils/CheckPosition'

const ButtonDownload = (props) => {
  const {
    className,
    description,
    document,
    disabled = false,
    hasDownloadIcon = false,
    isImage = false,
    name,
    parentPageNameForGtm,
    urlDownload,
  } = props

  const Icon = hasDownloadIcon ? StyleIconDownload : StyleIconMore
  const [visibleOverlay, setVisibleOverlay] = useState(null)
  const { setVisibleDownloadOverlay } = useContext(LayoutContext)

  const handleClickEvent = () => {
    if (parentPageNameForGtm) {
      downloadDocumentEvent({ parentPageNameForGtm, name })
    }
  }

  useEffect(() => {
    if (visibleOverlay && setVisibleDownloadOverlay) {
      return setVisibleDownloadOverlay(visibleOverlay)
    }
  }, [visibleOverlay])

  const url = urlDownload
    ? urlDownload
    : document?.contentfulAsset?.file?.url ||
      document?.cloudinary?.[0]?.original_secure_url ||
      document?.cloudinary?.[0]?.original_url ||
      document?.cloudinary?.[0]?.secure_url ||
      document?.cloudinary?.[0]?.url ||
      document?.url

  const handleClick = (url) => {
    if (url && hasDownloadIcon) {
      handleClickEvent()
      return downloadDocument(url)
    } else return window.open(url, '_blank')
  }

  const handleIconClick = (event) => {
    event.stopPropagation()
    const htmlElem = event.target.getBoundingClientRect()
    const position = CheckPosition(htmlElem)

    setVisibleOverlay({
      downloadGtmEvent: handleClickEvent,
      visibility: true,
      offsetX: position[0],
      offsetY: position[1],
      url: url,
    })
  }

  return (
    <StyledButtonDownload
      className={className}
      disabled={disabled}
      $variant={ButtonVariantEnum.secondary}
      onClick={() => hasDownloadIcon && handleClick(url)}
    >
      <StyledButtonText href={url} onClick={handleClickEvent} target="_blank">
        <StyledLabel title={name}>{name}</StyledLabel>
        {description && <StyledText>{description}</StyledText>}
      </StyledButtonText>
      {document?.cloudinary || document?.contentfulAsset ? (
        <StyledButtonContainer aria-label="more">
          <Icon onClick={(e) => handleIconClick(e)} />
        </StyledButtonContainer>
      ) : (
        <StyledWebcastContainer
          href={url}
          target="_blank"
          rel="noreferrer"
          aria-label="document"
        >
          {document?.webcast ? (
            <StyledWebcast />
          ) : isImage ? (
            <Icon />
          ) : (
            <StyledArrow />
          )}
        </StyledWebcastContainer>
      )}
    </StyledButtonDownload>
  )
}

ButtonDownload.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  document: PropTypes.object,
  hasDownloadIcon: PropTypes.bool,
  name: PropTypes.string,
  overlayPosition: PropTypes.string,
  parentPageNameForGtm: PropTypes.string,
}

export default ButtonDownload
